import { useEffect } from 'react';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import UpdatesSection from './components/UpdatesSection';
import FeaturesSection from './components/FeaturesSection';
import CarouselSection from './components/CarouselSection';
import CommentsSection from './components/CommentsSection';
import RankingSection from './components/RankingSection';
import ContactSection from './components/ContactSection';
import AppSection from './components/AppSection';
import TopicsSection from './components/TopicsSection';
import FaqSection from './components/FaqSection';
import CardsSection from './components/CardsSection';
import IndexSection from './components/IndexSection';
import MediaSection from './components/MediaSection';
import AboutSection from './components/AboutSection';
import Footer from './components/Footer';

export default function Home() {
  useEffect(() => {
    if (window.location.hash) {
      const id = window.location.hash;
      setTimeout(() => {
        const el = document.querySelector(id);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    }
  }, []);

  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <UpdatesSection />
        <FeaturesSection />
        <CarouselSection />
        <CommentsSection />
        <RankingSection />
        <ContactSection />
        <AppSection />
        <TopicsSection />
        <FaqSection />
        <CardsSection />
        <IndexSection />
        <MediaSection />
        <AboutSection />
      </main>
      <Footer />
    </>
  );
}